import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { baseUrls } from './appConstant';
import { catchError, retry, timeout } from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  constructor(private httpClient: HttpClient, 
    @Inject(PLATFORM_ID) platformId: string) {
      if (isPlatformBrowser(platformId)){
        this.isBrowser = true;
      }
    }
  isBrowser = false;

  getData(staticUrl: string){
    let url = baseUrls['base'] + staticUrl;
    return this.httpClient.get(url);
  }
  
  getbillData(staticUrl: string){
    let url = baseUrls['bill'] + staticUrl;
    return this.httpClient.get(url);
  }
  
  getsignupData(staticUrl: string){
      let url = baseUrls['bill'] + staticUrl;
      let headers: HttpHeaders = new HttpHeaders();
      let tokens= localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '';
      if(tokens){
        headers = headers.append('Token', tokens);
        return this.httpClient.get(url,{headers});
      }
      else{
        return this.httpClient.get(url);
      }
  }
  getuserData(staticUrl: string){
    let url = baseUrls['user'] + staticUrl;
    return this.httpClient.get(url);
  }
  getuserDataWithToken(staticUrl: string){
    let url = baseUrls['user'] + staticUrl;
    return this.httpClient.get(url, { headers: { 
      token: localStorage?.getItem('userToken') ? localStorage?.getItem('userToken') : "" 
    } 
  });
  }
  postuserData(staticUrl: string,data:any){
    let url= baseUrls['user']+staticUrl;
    return this.httpClient.post(url,data).pipe(
      catchError(this.handleError));
  }
  postuserDataWithToken(staticUrl: string,data:any){
    let url= baseUrls['user']+staticUrl;
    return this.httpClient.post(url,data, 
      {
        headers:
        {token: localStorage?.getItem("userToken") ? localStorage?.getItem("userToken") : "" }
      }
      ).pipe(
      catchError(this.handleError));
  }
  postbillData(staticUrl: string,data:any){
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.post(url,data).pipe(
      catchError(this.handleError));
  }
  getDatabill(staticUrl: string){
    let url = baseUrls['bill'] + staticUrl;
    return this.httpClient.get(url);
  }
  
  postFormDataBilling(staticUrl:string,data:any, header: any = ''):Observable<any> {
    const requestOptions = {
      headers: new HttpHeaders(header),
    };
    let url=baseUrls['bill']+staticUrl;
    return this.httpClient.post(url, data, requestOptions).pipe(
      catchError(this.handleError));
  }

  postFormData(staticUrl: string, data: any): Observable<any> {
    let url= baseUrls['base']+staticUrl;
    return this.httpClient.post(url,data).pipe(
      timeout(45000),
      catchError(this.handleError));
  }
  getDataFromExcel(staticUrl:string){
    let url = staticUrl;
    return this.httpClient.get(url,{ headers: new HttpHeaders({'Content-Type': 'application/json'}), responseType: 'blob'}).pipe(
      catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
      return of({ success:false, message: `Something bad happened. Please try again later.`, error: error.error });
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log('Backend response', error);
      // `Error Code: ${error.status}\nMessage: ${error.message}`;
      return of({ success:false, message: 'Something bad happened. Please try again later.', error: error.error });
    }
    // return an observable with a user-facing error message
    return of({ success:false, message: 'Something bad happened. Please try again later.' });
  }
  postForShopService(staticUrl: string,data:any){
    // console.log('postForShopService', this.isBrowser);
    if(this.isBrowser){
      let url= baseUrls['shop']+staticUrl;
      if(localStorage.getItem('userToken')){
        return this.httpClient.post (url,data, {headers: {token: localStorage.getItem('userToken')}}).pipe(
          catchError(this.handleError));
      }
      else{
        return this.httpClient.post (url,data).pipe(
          catchError(this.handleError));
      }
    }
  }
  getForShopService(staticUrl: string){
    let url = baseUrls['shop'] + staticUrl;
    if(localStorage.getItem('userToken')){
      return this.httpClient.get(url, {headers :{ token : localStorage.getItem('userToken')}});
    }
    else{
      return this.httpClient.get(url);
    }
  }
  getDigi(staticUrl: string){
    let url = baseUrls['digi'] + staticUrl;
    return this.httpClient.get(url);
  }
  sendInviteMail(staticUrl: string,data:any){
    // console.log('postForShopService', this.isBrowser);
    if(this.isBrowser){
      let url= baseUrls['user']+staticUrl;
      if(localStorage.getItem('userToken')){
        return this.httpClient.post(url,data, {headers: {token: localStorage.getItem('userToken')}}).pipe(
          catchError(this.handleError));
      }
      else{
        return this.httpClient.post (url,data).pipe(
          catchError(this.handleError));
      }
    }
  }
  postbillDataWithOrWithoutToken(staticUrl: string,data:any){
    let url= baseUrls['bill']+staticUrl;
    if(localStorage.getItem('userToken')){
      return this.httpClient.post(url,data, {headers: {Token : localStorage.getItem('userToken')}}).pipe(
        catchError(this.handleError));
    }
    else{
      return this.httpClient.post(url,data).pipe(
        catchError(this.handleError));
    }
  }

  postBaseDataWithToken(staticUrl: string, data: any): Observable<any> {
    let url= baseUrls['base']+staticUrl;
    return this.httpClient.post(url,data,  {headers: {Token : localStorage.getItem('userToken')}}).pipe(
      timeout(4500),
      catchError(this.handleError));
  }


  postVenderSignup(staticUrl: string,data:any){
    let url= baseUrls['base']+staticUrl;
    if(localStorage.getItem('userToken')){
      return this.httpClient.post(url,data, {}).pipe(
        catchError(this.handleError));
    }
    else{
      return this.httpClient.post(url,data).pipe(
        catchError(this.handleError));
    }
  }

  postvenderSignupPayment(staticUrl:string,data:any){
    let url = baseUrls['bill'] + staticUrl;
    if(localStorage.getItem('venderToken')){
      return this.httpClient.post(url,data, {}).pipe(
        catchError(this.handleError));
    }
    else{
      return this.httpClient.post(url,data).pipe(
        catchError(this.handleError));
    }
  }
}